const VARIANTS = [
    {
        id: "v1",
        src: "/assets/hero-mobile-key.png",
        name: "V1 · Llave de cristal (actual)",
        desc: "Llave de luz y cristal esmerilado, la que está en producción ahora.",
    },
    {
        id: "v2",
        src: "/assets/hero-mobile-key-v2.png",
        name: "V2 · Portal de luz",
        desc: "Cerradura luminosa como portal de acceso. Concepto 'puerta de entrada'.",
    },
    {
        id: "v3",
        src: "/assets/hero-mobile-key-v3.png",
        name: "V3 · Llave digital",
        desc: "Constelación de red formando la llave. La más tecnológica.",
    },
    {
        id: "v4",
        src: "/assets/hero-mobile-key-v4.png",
        name: "V4 · Aurora",
        desc: "Ondas de luz con la llave en espacio negativo. La más sutil y minimalista.",
    },
];

function PhoneFrame({ v }) {
    return (
        <div
            data-testid={`variant-${v.id}`}
            className="rounded-[2.2rem] border border-white/15 bg-[#112338] overflow-hidden shadow-2xl shadow-black/50 w-[300px] shrink-0"
        >
            <div className="relative aspect-[9/16]">
                <img
                    src={v.src}
                    alt={v.name}
                    className="absolute inset-0 w-full h-full object-cover blur-[3px] scale-105"
                />
                <div className="absolute inset-0 bg-[#1F3B5B]/35 mix-blend-multiply" />
                <div className="absolute inset-0 bg-gradient-to-b from-[#112338]/80 via-[#112338]/55 to-[#112338]/90" />
                <div className="absolute inset-0 blueprint-grid" />

                <div className="relative h-full flex flex-col justify-center px-6">
                    <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 self-start">
                        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                        <span className="font-mono text-[8px] uppercase tracking-[0.2em] text-white/80">
                            Seguridad y confianza, en línea
                        </span>
                    </div>
                    <h3 className="mt-4 font-display font-extrabold text-white text-[26px] leading-[1.08] tracking-tight">
                        Tu hipoteca{" "}
                        <span className="text-emerald-400">online</span> con
                        condiciones inmejorables.
                    </h3>
                    <p className="mt-3 text-[11px] text-slate-300 leading-relaxed">
                        Estudio gratuito, asesoramiento personalizado y gestión
                        integral hasta la entrega de llaves.
                    </p>
                    <div className="mt-5 flex flex-col gap-2.5">
                        <span className="rounded-full bg-emerald-500 text-[#0B1A2B] font-bold text-[12px] px-5 py-2.5 text-center">
                            Simula tu hipoteca
                        </span>
                        <span className="rounded-full border border-white/25 text-white font-semibold text-[12px] px-5 py-2.5 text-center">
                            Habla con un asesor
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function Variants() {
    return (
        <div
            data-testid="variants-page"
            className="min-h-screen bg-[#0B1A2B] noise-overlay px-6 py-14"
        >
            <div className="max-w-6xl mx-auto">
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-emerald-400">
                    Vista previa interna
                </p>
                <h1 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                    Elige el fondo del hero móvil
                </h1>
                <p className="mt-3 text-slate-400 max-w-xl text-[15px]">
                    Las cuatro variantes con el overlay y el texto reales
                    aplicados. Dime cuál prefieres (V1, V2, V3 o V4) y la dejo
                    como fondo definitivo.
                </p>

                <div className="mt-12 flex flex-wrap gap-10 justify-center">
                    {VARIANTS.map((v) => (
                        <div key={v.id} className="flex flex-col items-center gap-4">
                            <PhoneFrame v={v} />
                            <div className="text-center max-w-[300px]">
                                <p className="font-display font-semibold text-white">
                                    {v.name}
                                </p>
                                <p className="text-sm text-slate-400 mt-1">
                                    {v.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
